export default __webpack_public_path__ + "static/media/mn_tea_sub_2.4c6ee95e.png";